define.alias("@ember/render-modifiers/modifiers/will-destroy", "media/modifiers/will-destroy");